import { RegisterOptions } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { FormValues } from './index.context'

export const defaultValues: FormValues = {
  clientId: null,
  accountId: undefined,
  file: '',
  mappingFormat: null,
}

export const FILE_ACCEPT: {
  [key: string]: string
} = {
  txt: 'text/plain',
  csv: 'text/csv',
  excel: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  excel_xls: 'application/vnd.ms-excel',
}
export const LIMITED_FILE_SIZE = 10485760 // 10485760 bytes = 10 Mebibytes // refference: https://convertlive.com/u/convert/megabytes/to/bytes#10
export const LIMITED_FILE_SIZE_IN_MB = 10 // unit: MB

export enum ISSUED_CHECK_STATUS {
  PROCESSING = 0,
  ISSUED = 1,
  PROCESSED = 2,
  PROCESSED_WITH_EXCEPTION = 3,
  REJECTED = 4,
  FAILED = 5,
}

export const useFormRules = (): Record<
  keyof FormValues,
  Omit<RegisterOptions<FormValues>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs' | 'disabled'>
> => {
  const { t } = useTranslation()
  return {
    clientId: {
      maxLength: {
        value: 200,
        message: t('SubmitIssuedCheck:validation.max_length.client_name', { maxLength: 200 }),
      },
      required: {
        value: true,
        message: t(`SystemMessages:${SYSTEM_MESSAGE_IDS.INVALID_FIELD_VALIDATION}`, {
          Required_Field: t(`SubmitIssuedCheck:title.client_name`),
        }),
      },
    },
    accountId: {
      maxLength: {
        value: 200,
        message: t('SubmitIssuedCheck:validation.max_length.account_name', { maxLength: 200 }),
      },
      validate: {
        required: (value) => {
          if (value === undefined) {
            return t(`SystemMessages:${SYSTEM_MESSAGE_IDS.INVALID_FIELD_VALIDATION}`, {
              Required_Field: t(`SubmitIssuedCheck:title.account_name`),
            })
          }
          return true
        },
      },
    },
    file: {
      required: {
        value: true,
        message: t(`SystemMessages:${SYSTEM_MESSAGE_IDS.INVALID_FIELD_VALIDATION}`, {
          Required_Field: t(`SubmitIssuedCheck:title.select_file`),
        }),
      },
    },
    mappingFormat: {
      required: {
        value: true,
        message: t(`SystemMessages:${SYSTEM_MESSAGE_IDS.INVALID_FIELD_VALIDATION}`, {
          Required_Field: t(`SubmitIssuedCheck:title.mapping_format`),
        }),
      },
    },
  }
}
